import Skeleton from 'react-loading-skeleton'
import * as S from '../StampedReviews.styles'

export const StampedReviewsMobileSkeleton = (): JSX.Element => {
  return (
    <S.MobileMainContainer>
      <S.MainTitle>
        <Skeleton width={'80%'} height={'3rem'} />
        <Skeleton width={'45%'} height={'3rem'} />
      </S.MainTitle>

      <S.ButtonContainer>
        <S.StarContainer>
          <Skeleton width={'4.4rem'} height={'3.5rem'} />
          <S.StarSkeleton count={5} wrapper={S.Star} />
          <div className="skeleton-reviews-count">
            <Skeleton width={'9rem'} height={'1rem'} />
          </div>
        </S.StarContainer>

        <Skeleton width={'100%'} height={'3.8rem'} />

        <Skeleton width={'100%'} height={'3.8rem'} />
      </S.ButtonContainer>

      <S.TabsContainer>
        <Skeleton width={'9.5rem'} height={'1.9rem'} />
        <Skeleton width={'9.5rem'} height={'1.9rem'} />
      </S.TabsContainer>

      <S.Review>
        <S.SortContainer>
          <Skeleton width={'12.4rem'} height={'1.2rem'} />
        </S.SortContainer>

        <S.DetailsTitle>
          <Skeleton width={'10rem'} height={'1.8rem'} />
          <Skeleton width={'7.8rem'} height={'1.8rem'} />
        </S.DetailsTitle>

        <S.DetailsTitle>
          <S.VerifiedUser>
            <Skeleton circle width={'1.2rem'} height={'1.2rem'} />
            <Skeleton width={'10rem'} height={'1.2rem'} />
          </S.VerifiedUser>
          <Skeleton count={5} wrapper={S.Star} width={'2rem'} />
        </S.DetailsTitle>

        <S.ReviewText>
          <Skeleton width={'70%'} height={'1.5rem'} />
          <Skeleton width={'98%'} height={'1.4rem'} />
          <Skeleton width={'90%'} height={'1.4rem'} />
          <Skeleton width={'95%'} height={'1.4rem'} />
          <Skeleton width={'70%'} height={'1.4rem'} />
          <Skeleton width={'97%'} height={'1.4rem'} />
          <Skeleton width={'35%'} height={'1.4rem'} />
        </S.ReviewText>
      </S.Review>
    </S.MobileMainContainer>
  )
}
